// @ts-expect-error moduleResolution:nodenext issue 54523
import { html } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property, state } from 'lit/decorators.js';
import LightElement from './light-element.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { classMap } from 'lit/directives/class-map.js';
import Helpers from '../../typescript/modules/helpers.js';

@customElement('product-viewer-container')
export default class ProductViewerContainer extends LightElement {

	@property({ type: Boolean })
	standalone: boolean;

	@state()
	showAnimation: boolean = false;

	private closeAnimationDuration: number = 300;

	connectedCallback() {
		super.connectedCallback();
		window.addEventListener('keydown', this.handleKeydown.bind(this));
		document.addEventListener('closeProductViewer', this.close.bind(this), { once: true });
		if (this.standalone) {
			setTimeout(() => {
				this.showAnimation = true;
			}, 300);
		}
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		window.removeEventListener('keydown', this.handleKeydown);
	}

	private close() {
		this.showAnimation = false;
		if (this.parentElement) {
			if (this.standalone) {
				setTimeout(() => {
					if (this.parentElement.parentElement) {
						this.parentElement.parentElement.removeChild(this.parentElement);
					}	
					const triggerUpdateWishlistButtons = Helpers.createCustomEventForDispatch('updateWishlistButtons');
					document.dispatchEvent(triggerUpdateWishlistButtons);
					const triggerCloseProductViewer = Helpers.createCustomEventForDispatch('productViewerClosed');
					document.dispatchEvent(triggerCloseProductViewer);
				}, this.closeAnimationDuration);
			}
		}
	}

	private handleKeydown(event: KeyboardEvent) {
		if (event.key === "Escape") {
			this.close();
		}
	}

	render() {

		if (this.standalone) {
			return html`
			<div class="c-slidy-outy c-slidy-outy--disallow-animations c-slidy-outy--active" role="dialog" aria-labelledby="slidy-outy-title" style="display: block;">
					<div class="c-slidy-outy__inner">
							<div class="c-slidy-outy__background" data-atb-background="" data-test="atb-background" @click="${this.close}"></div>
							<div class="c-slidy-outy__detail ${classMap({ "c-slidy-outy__detail--active": this.showAnimation })}" data-product-viewer data-test="product-viewer-overlay">
									<div class="c-slidy-outy__detail__fade" data-product-viewer-fade></div>
									<div class="c-slidy-outy__detail__inner" data-product-viewer-inner>
											<div class="c-slidy-outy__detail__inner__inner">
													<div class="c-slidy-outy__detail__container" data-product-viewer-container>
														${this.getSlot('main')}
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
			`;
		}

		return this.getSlot('main');

	}

}
